import { Box } from '@dropbox/dig-foundations';
import { PictogramIcon } from '@dropbox/dig-icons';
import { Title } from '@dropbox/dig-components/typography';
import classnames from 'classnames';
import React from 'react';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import whiteLabelStyles from 'signer-app/white-labeling/theme-provider.module.css';
import styles from './embedded-terminal-page.module.css';

type Props = {
  children: React.ReactNode;
  pageClassName?: string;
  pictogram: React.ComponentProps<typeof PictogramIcon>['src'];
  title: React.ReactNode;
};

export function EmbeddedTerminalPage({
  children,
  pageClassName,
  pictogram,
  title,
}: Props): JSX.Element {
  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        className={classnames(
          styles.page,
          whiteLabelStyles.pageBackground,
          pageClassName,
        )}
        backgroundColor="Background Base"
      >
        <div className={styles.content}>
          <PictogramIcon className={styles.pictogram} src={pictogram} />
          <Title className={styles.title}>{title}</Title>
          {children}
        </div>
      </Box>
    </WhiteLabelThemeProvider>
  );
}
